import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  buttonActionsContainer: {
    margin: '0.5rem',
  },
  dialogContentContainer: {
    marginBottom: 10,
  },
  bold: {
    fontWeight: 700,
  },
  title: {
    fontSize: '1.2rem',
    display: 'flex',
    gap: '0.5rem',
  },
}));
